module.exports = __webpack_public_path__ + "img/2010 winteressen 003.e4dd0f4d.jpg";